"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = StepLayout;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _configurator = _interopRequireDefault(require("../../../styles/configurator.css"));
var _title = _interopRequireDefault(require("./title/title"));
var _carousel = _interopRequireDefault(require("./carousel/carousel"));
var _disclaimer = _interopRequireDefault(require("../../disclaimer/disclaimer"));
function StepLayout(_ref) {
  var theme = _ref.theme,
    title = _ref.title,
    rightSlot = _ref.rightSlot,
    direction = _ref.direction,
    disclaimerData = _ref.disclaimerData,
    carouselData = _ref.carouselData,
    disclaimer = _ref.disclaimer,
    market = _ref.market;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['container-fluid'], _configurator["default"].stepContent)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme.row)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-6'])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme.row, _configurator["default"].loaderWrapper)
  }, carouselData && /*#__PURE__*/_react["default"].createElement(_carousel["default"], {
    data: carouselData,
    theme: theme
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-6'], theme.marginBottom40),
    dir: direction
  }, title && /*#__PURE__*/_react["default"].createElement(_title["default"], {
    title: title,
    disclaimerData: disclaimerData,
    theme: theme
  }), rightSlot, disclaimer && market !== 'us' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx["default"])(theme.smallType, _configurator["default"].stepDisclaimer)
  }, disclaimer))), disclaimer && market === 'us' && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-md-offset-1'], theme['col-md-10'])
  }, /*#__PURE__*/_react["default"].createElement(_disclaimer["default"], {
    theme: theme,
    headline: "Disclaimer",
    content: disclaimer
  }))));
}